import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EntrySelect } from 'src/app/shared/models/EntrySelect.model';
import { RestService } from 'src/app/shared/services/rest.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';
import { WebSocketContent } from 'src/app/shared/models/webSocketContent';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-listagem-chamados',
  templateUrl: './listagem-chamados.component.html',
  styleUrls: ['./listagem-chamados.component.css']
})
export class ListagemChamadosComponent implements OnInit {
  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    this.observador.unsubscribe();
  }
  listaChamados: Array<chamadoTable> = [];
  limit: number = 10;
  totalRegistros: number = 0;
  page: number = 1;
  listaCategorias: Array<EntrySelect> = environment.categoriaChamado;
  listaStatus: Array<EntrySelect> = environment.statusChamado;
  master: boolean = false;
  chamado_atual: any;
  form: FormGroup;
  listaGestores: Array<EntrySelect> = [];
  _not: string = null;
  uuid_user: string;
  listaExecutando: Array<any> = [];
  ciclo: boolean = false;
  cicloAtivo: boolean = false;
  observador: Subscription;
  observador2: Subscription;
  constructor(
    private rest: RestService,
    private session: SessionService,
    private router: Router,
    private formB: FormBuilder,
    private app: AppComponent
  ) { }

  ngOnInit(): void {
    this.ciclo = this.session.isCiclo();
    this.cicloAtivo = this.session.isCiclo();
    this.uuid_user = this.session.getUUIDUsuario();
    this.master = this.isEmpresaMaster();
    this.form = this.formB.group({
      gestor: [null, [Validators.nullValidator]],
      status: [null, [Validators.nullValidator]],
      categoria: [null, [Validators.nullValidator]],
      protocolo: [null, [Validators.nullValidator]]
    });
    if (this.master) {
      this.rest.getUsersPaged(1, 100).subscribe((data: any) => {
        if (data.status == 'success') {
          if (data.data.length > 0) {
            this.listaGestores = [];
            data.data.forEach((e: any) => {
              this.listaGestores.push({ 'label': e.nome, 'value': e.uuid_usuario });
            });
          }
        }
      });
    }
    this.loadItens();
    this.observador = this.app.notificacao.subscribe((msg: WebSocketContent) => {
      if (msg.code == 13) {
        this.loadItens(true);
      }
    });
    this.observador2 = this.app.interacaoChamado.subscribe((msg: WebSocketContent) => {
      if (msg.code == 27) {
        let teste = false;
        this.listaChamados.forEach((e: chamadoTable) => {
          if (e.protocolo == msg.uuid_chamado) {
            teste = true;
          }
        });
        if (teste || ((this.cicloAtivo && this.ciclo) && msg.content == 'Atendimento Ciclo')) {
          this.loadItens();
        }
      }
    })
  }

  loadItens(ignoreFiltro: boolean = false) {
    let flag = '';
    if (!ignoreFiltro) {
      let gestor = this.form.get('gestor').value;
      let status = this.form.get('status').value;
      let protocolo = this.form.get('protocolo').value;
      let categoria = this.form.get('categoria').value;
      if (!(gestor || status || protocolo || categoria)) flag = "and chamados.status != 'Finalizado'";
      else {
        if (gestor) flag += `and chamados.uuid_gestor = '${gestor}'`;
        if (status) flag += `and chamados.status = '${status}'`;
        if (protocolo) flag += `and chamados.protocolo = '${protocolo}'`;
        if (categoria) flag += `and chamados.categoria = '${categoria}'`;
      }
    } else flag = null;
    if (this.cicloAtivo) flag += `and chamados.status = 'Atendimento Ciclo'`;
    this.rest.obterChamados(this.limit, this.page, flag, this.cicloAtivo).subscribe((data: any) => {
      if (data.status == 'success') {
        this.totalRegistros = data.total_registros;
        this.listaChamados = data.data;
      } else if (data.status == 'erro') { this.listaChamados = []; this.totalRegistros = 0; }
    });
    this._not = null;
  }

  obterCategoria(v: any) {
    v = String(v);
    let r = null;
    this.listaCategorias.forEach((d: EntrySelect) => {
      if (d.value == v) { r = d.label; return r; }
    });
    return r;
  }

  isEmpresaMaster(): boolean {
    return this.session.isMaster();
  }

  pageChange(event) {
    this.page = event;
    this.loadItens();
  }

  retornaPrioridade(prioridade: any) {
    if (this.master)
      switch (prioridade) {
        case (1): { return 'Alta'; }
        case (2): { return 'Media'; }
        case (3): { return 'Baixa'; }
        default: { return 'Pendente'; }
      }
  }

  criptografarMensagem(value: string, key: string) {
    return CryptoJS.AES.encrypt(value, key).toString();
  }

  retornaClasseDePrioridade(prioridade: any) {
    if (this.master)
      switch (prioridade) {
        case (1): { return 'p-alta'; }
        case (2): { return 'p-media'; }
        case (3): { return 'p-baixa'; }
        default: { return 'p-null'; }
      }
  }

  abrirChamado(protocolo, dados: any) {
    this.router.navigateByUrl('chamados/interacao/' + protocolo, { state: { dados_chamado: dados } });
  }

  notificacaoAtiva(protocolo) {
    let r = false;
    this.listaChamados.forEach((e: any) => {
      if (e.protocolo == protocolo) { if (String(e.notificacao).includes(this.uuid_user)) { r = true; return } }
    });
    return r;
  }

  alternarChamadosCiclo() {
    this.cicloAtivo = !this.cicloAtivo;
    this.loadItens();
  }

  async adicionarNotificacao(protocolo) {
    let index = this.listaExecutando.indexOf(protocolo);
    if (index == -1) {
      this.listaExecutando.push(protocolo);
      this.rest.adicionarNotificacaoChamado(protocolo).subscribe((data: any) => {
        if (data.status == 'success') {
          this.alterarListaNotificacao(protocolo, false)
        }
        this.listaExecutando.splice(index, 1)
      });
    }
  }

  async removerNotificacao(protocolo) {
    let index = this.listaExecutando.indexOf(protocolo);
    if (index == -1) {
      this.rest.removerNotificacaoChamado(protocolo).subscribe((data: any) => {
        if (data.status == 'success') {
          this.alterarListaNotificacao(protocolo, true);
        }
        this.listaExecutando.splice(index, 1)
      });
    }
  }

  async alterarListaNotificacao(protocolo: string, remove: boolean) {
    this.listaChamados.forEach((e: any) => {
      if (e.protocolo == protocolo) {
        if (remove) {
          e.notificacao = String(e.notificacao).replace(this.uuid_user, ''); return
        } else {
          e.notificacao += this.uuid_user + ','; return
        }
      }
    });
  }
}

export class chamadoTable {
  data_hora_abertura: Date;
  empresa: String;
  gestor: string;
  assunto: string;
  protocolo: string;
}
